import * as actions from './action';
import reducers from './reducer';

export const UserSearchResults = { actions, reducers };
export { UserSearchResultState } from './reducer';
